/* ============================================================================
   NVWA — Académie du Vin Library
   5 Sep 2026. Two small behaviours. Everything else on this page is server
   rendered on purpose: the browse tiles and study chips are real links to
   native ?filter.p.m.custom.* URLs, so filtering works with JavaScript off,
   stays crawlable, and cannot disagree with the counts Shopify printed on it.

   1. Browse band tabs — swaps the region / topic panel.
      Both panels are in the DOM already. With JS off, both are visible, which
      is a worse layout but a working page. Progressive, not required.

   2. Reading-list "Add all" — posts several books to the cart in one request.
      A plain form POST to /cart/add only carries one line item, so this is the
      one place a fetch is genuinely needed.

   No dependencies. Deferred from sections/main-collection.liquid.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- 1. Browse band tabs --------------------------------------------- */
  var band = document.querySelector('[data-nvl-browse]');
  if (band) {
    var tabs = band.querySelectorAll('[data-nvl-tab]');
    var panels = band.querySelectorAll('[data-nvl-panel]');

    // Panels start with the topic list hidden via the `hidden` attribute, set
    // server-side. Toggle `hidden` rather than inline display so the theme's
    // own [hidden] rule keeps working and nothing depends on a style value.
    Array.prototype.forEach.call(tabs, function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var want = tab.getAttribute('data-nvl-tab');

        Array.prototype.forEach.call(tabs, function (t) {
          t.setAttribute('aria-current', String(t.getAttribute('data-nvl-tab') === want));
        });
        Array.prototype.forEach.call(panels, function (p) {
          p.hidden = p.getAttribute('data-nvl-panel') !== want;
        });
      });
    });
  }

  /* ---- 2. Scope the search to the imprint ------------------------------ */
  // Shopify's /search indexes the whole store, so on submit we append
  // vendor:"…" to the query. All 103 books share one vendor, which makes this
  // an exact scope with no Search & Discovery filter to configure.
  // If this listener never runs, the form still submits and still searches —
  // wider results, never a dead box.
  var searchForm = document.querySelector('[data-nvl-search]');
  if (searchForm) {
    searchForm.addEventListener('submit', function () {
      var input = searchForm.querySelector('input[name="q"]');
      var vendor = searchForm.getAttribute('data-scope-vendor');
      if (!input || !vendor) return;

      var term = input.value.trim();
      if (!term) return; // an empty scoped query returns the whole imprint as a search page; let the form's own required-ness handle it

      // Don't double-scope if the shopper edited the box after a previous search.
      if (term.indexOf('vendor:') === -1) {
        input.value = term + ' vendor:"' + vendor + '"';
      }
    });

    // Strip the scope back out of the visible box on a results page, so the
    // shopper sees what they typed rather than our query syntax.
    var q = searchForm.querySelector('input[name="q"]');
    if (q && q.value.indexOf('vendor:') > -1) {
      q.value = q.value.replace(/\s*vendor:"[^"]*"\s*/g, '').trim();
    }
  }

  /* ---- 3. Reading-list bundles ----------------------------------------- */
  // Each button carries data-nvl-add="<variantId>,<variantId>,…". Sold-out
  // books are omitted server-side, so the list is always addable — a bundle
  // button that fails on one line item is worse than a bundle of four.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-nvl-add]') : null;
    if (!btn) return;
    e.preventDefault();

    var ids = (btn.getAttribute('data-nvl-add') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    if (!ids.length) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; })
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        // Say what went wrong and what to do, on the button itself. No alert()
        // — a modal dialog would block the page, and this is recoverable.
        btn.disabled = false;
        btn.textContent = 'Could not add — try again';
        setTimeout(function () { btn.textContent = original; }, 4000);
      });
  });
})();
